<template>
  <v-col cols="12" class="px-0">
    <v-list class="py-0 inspections-list" dense>
      <v-list-item
        v-for="inspection in items"
        :key="inspection.id"
        class="inspection-element hover-list-element px-2"
        @click="openInspection(inspection.id)"
      >
        <v-list-item-content>
          <v-list-item-title :title="inspection.name" class="text-body-2">
            <v-row no-gutters align="center">
              <v-col cols="auto" class="px-1">
                <div class="text-body-2 inspections-list-text">
                  {{ $dayjs(inspection.date_carried_out).format(localeDateFormat) }}
                </div>
              </v-col>
              <v-col cols="auto">
                <v-subheader
                  class="text-caption font-italic px-0"
                  style="height: auto;"
                  v-text="`(${users[inspection.user_carried_out] ? users[inspection.user_carried_out].name : ''})`"
                />
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>
<script>
import { get } from 'vuex-pathify';

export default {
  name: 'InspectionsList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    localeDateFormat: {
      validatior: value => {
        return ['ll', 'l', 'LL', 'L'].indexOf(value) !== -1;
      },
      default: 'L',
    },
  },
  computed: {
    users: get('users/users'),
  },
  methods: {
    openInspection(id) {
      this.$emit('openInspection', id);
    },
  },
};
</script>
<style lang="scss" scoped>
.inspection-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.inspections-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.inspections-list-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
